/* Nick's Aquarium, 11 Oct 2026: filter chips for the collection panels.
 *
 * Adds Reef safe, Care level, Origin, Size, Tank size suitability and In stock only to the custom toolbar
 * (chips are rendered by snippets/livestock-sorting.liquid). It does not change
 * assets/fish-collection-panels.js: it wraps two of that component's methods so a card
 * is hidden when it fails a chip as well as the search and price box. Values come from
 * the data-* attributes on each card <li> (snippets/livestock-sort-data.liquid).
 *
 * Chips in one row are "any of" (Easy or Moderate). Rows combine (Reef safe and Easy).
 * To undo: remove the script line in snippets/livestock-sorting.liquid and this file.
 */
(() => {
  if (window.__lvFilters) return;
  window.__lvFilters = true;

  const state = { reef: false, instock: false, care: new Set(), origin: new Set(), size: new Set(), tank: new Set() };
  const hasCardFilters = () => state.reef || state.care.size > 0 || state.origin.size > 0 || state.size.size > 0 || state.tank.size > 0;
  const anyOf = (list, set) => (list || '').split('|').some((v) => v && set.has(v));

  // 14 Oct 2026: Tank size suitability. A fish shows under a band only when its minimum tank
  // size fits the smallest tank in that band. Worked out from the same minimum tank size the
  // card and product page show (data-tank), so the filter always agrees with the page. Falls
  // back to custom.tank_size_suitability (data-tankbands) only when a card has no tank number.
  const TANK_LO = { 'Nano (20 to 39 L)': 20, '40 to 74 L': 40, '75 to 119 L': 75, '120 to 199 L': 120, '200 to 299 L': 200, '300 to 499 L': 300, '500 to 749 L': 500, '750 to 999 L': 750, '1000 L plus': 1000 };
  const tankBands = (li) => {
    const n = parseFloat(li.dataset.tank || '');
    if (isFinite(n)) return Object.keys(TANK_LO).filter((b) => n <= TANK_LO[b] || b === '1000 L plus');
    return (li.dataset.tankbands || '').split('|').filter(Boolean);
  };

  customElements.whenDefined('fish-collection-panels').then(() => {
    const Panels = customElements.get('fish-collection-panels');
    const proto = Panels.prototype;
    if (proto.__lvWrapped) return;
    proto.__lvWrapped = true;

    const baseApply = proto.applyFilters;
    proto.applyFilters = function (grid) {
      baseApply.call(this, grid);
      if (!grid || !hasCardFilters()) return;
      Array.from(grid.children).forEach((li) => {
        if (li.tagName !== 'LI' || li.classList.contains('lv-hide')) return;
        let hide = false;
        if (state.reef && li.dataset.reef !== '1') hide = true;
        if (state.care.size && !state.care.has(li.dataset.care || '')) hide = true;
        if (state.origin.size && !anyOf(li.dataset.origins, state.origin)) hide = true;
        if (state.size.size && !anyOf(li.dataset.sizes, state.size)) hide = true;
        if (state.tank.size && !tankBands(li).some((b) => state.tank.has(b))) hide = true;
        if (hide) li.classList.add('lv-hide');
      });
    };

    // The lazy loader refreshes each new page of cards without re-counting, so keep the
    // counts and empty panels in step while a chip is on.
    const baseRefresh = proto.refreshGrid;
    proto.refreshGrid = function (grid) {
      baseRefresh.call(this, grid);
      if (hasCardFilters() || state.instock) this.updateSearchState();
    };

    const baseState = proto.updateSearchState;
    proto.updateSearchState = function () {
      baseState.call(this);
      const root = this.closest('.livestock-collection');
      if (!root) return;
      // A chip counts as a search: the In Stock / Out of Stock headings step aside and an
      // empty panel hides, exactly as when the search box has text in it.
      if (hasCardFilters()) root.classList.add('lv-searching');
      root.classList.toggle('lv-instock-only', state.instock);

      // The drawer's "See 443 items" button counts the whole collection. While a chip is on,
      // show how many cards are actually left; put the original label back when they are off.
      const count = (g) => (g ? Array.from(g.children).filter((li) => li.tagName === 'LI' && !li.classList.contains('lv-hide')).length : 0);
      document.querySelectorAll('.facets__see-results').forEach((btn) => {
        if (btn.dataset.lvLabel === undefined) btn.dataset.lvLabel = btn.textContent.trim();
        if (hasCardFilters() || state.instock) {
          const n = count(this.inGrid) + (state.instock ? 0 : count(this.outGrid));
          btn.textContent = 'See ' + n + (n === 1 ? ' item' : ' items');
        } else {
          btn.textContent = btn.dataset.lvLabel;
        }
      });
    };
  });

  document.addEventListener('click', (e) => {
    const chip = e.target.closest('[data-lv-filter]');
    if (!chip) return;
    const group = chip.getAttribute('data-lv-filter');
    const value = chip.getAttribute('data-value') || '';
    const on = chip.getAttribute('aria-pressed') !== 'true';
    document.querySelectorAll('[data-lv-filter="' + group + '"][data-value="' + value + '"]').forEach((c) => {
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (group === 'reef' || group === 'instock') state[group] = on;
    else if (state[group]) (on ? state[group].add(value) : state[group].delete(value));

    const panels = document.querySelector('fish-collection-panels');
    if (!panels) return;
    // Like search, a chip must cover every product, so pull in the whole out-of-stock set
    // unless the shopper only wants what is in stock.
    if (hasCardFilters() && !state.instock && typeof panels.loadAllOutOfStock === 'function') panels.loadAllOutOfStock();
    if (typeof panels.refreshAll === 'function') panels.refreshAll();
  });
})();
